import { produce } from 'immer';
import { useMemo, useState } from 'react';

let lastKey = 0;
export function useOptimistic(data) {
  const [callbacks, setCallbacks] = useState([]);

  const appliedData = useMemo(() => {
    return callbacks.reduce((acc, cur) => produce(acc, cur.cb), data);
  }, [data, callbacks]);

  function applyOptimisticUpdate(cb, promise, keyToOverwrite) {
    const key = keyToOverwrite ?? ++lastKey;
    const item = { key, cb };
    setCallbacks(prev => {
      const i = prev.findIndex(prevItem => prevItem.key === key);
      if (i > -1) {
        return [...prev.slice(0, i), item, ...prev.slice(i + 1)];
      }
      return [...prev, item];
    });

    if (promise) {
      promise
        .catch(() => {})
        .finally(() => {
          setCallbacks(prev => prev.filter(prevItem => prevItem.key !== key));
        });
    }

    return key;
  }

  return [appliedData, applyOptimisticUpdate];
}

export default useOptimistic;
